export default [
  {
    path: '/home',          //首页
    component: (resolve) => require(['@/views/system_setting/home/home'], resolve),
    hidden: true,
    meta: {
      title: 'global.users',
      code:'mgr',
    },
    children: [
      {
        path: '/',        //系统首页
        component: resolve => require(['@/views/home_page/home_page'], resolve),
        meta: {
          title: '首页',
          code:'mgr',
        }
      },
      {
        path: 'home_page',        //系统首页
        component: resolve => require(['@/views/home_page/home_page'], resolve),
        meta: {
          title: '首页',
          code:'mgr',
        }
      },
      {
        path: 'user_management',        //用户管理
        component: resolve => require(['@/views/system_setting/user_management/user_management'], resolve),
        meta: {
          title: 'global.users',
          code:'mgr',
        }
      },
      {
        path: 'role_management',         //角色管理
        component: resolve => require(['@/views/system_setting/role_management/role_management'], resolve),
        meta: {
          title: 'global.roles',
          code:'role',
        }
      },
      {
        path: 'dept_management',         //部门管理
        component: resolve => require(['@/views/system_setting/dept_management/dept_management'], resolve),
        meta: {
          title: 'global.depts',
          code:'dept',
        }
      },
      {
        path: 'position_management',        //职位管理
        component: resolve => require(['@/views/system_setting/position_management/position_management'], resolve),
        meta: {
          title: 'global.posts',
          code:'SYS_POSITION',
        }
      },
      {
        path: 'dict_management',            //字典管理
        component: resolve => require(['@/views/system_setting/dict_management/dict_management'], resolve),
        meta: {
          title: 'global.dict_type',
          code:'dict',
        }
      },
      {
        path: 'menu_management',            //菜单管理
        component: resolve => require(['@/views/system_setting/menu_management/menu_management'], resolve),
        meta: {
          title: 'global.menus',
          code:'menu',
        }
      },
      {
        path: 'login_log',                 //登录日志
        component: resolve => require(['@/views/system_setting/login_log/login_log'], resolve),
        meta: {
          title: 'global.login_log',
          code:'loginLog',
        }
      },
      {
        path: 'business_log',             //业务日志
        component: resolve => require(['@/views/system_setting/business_log/business_log'], resolve),
        meta: {
          title: 'global.business_log',
          code:'log',
        }
      },
      {
        path: 'notice_management',          //通知管理
        component: resolve => require(['@/views/system_setting/notice_management/notice_management'], resolve),
        meta: {
          title: 'global.messages',
          code:'notice',
        }
      },
      {
        path: 'tenant_management',           //租户管理
        component: resolve => require(['@/views/system_setting/tenant_management/tenant_management'], resolve),
        meta: {
          title: 'global.tenants',
          code:'tenant_info',
        }
      },

    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/module/system_setting.js